// Vendors
import {
  TrackingEventsEnumeration,
  TrackingLinkEventReturnType,
} from '@gruposantander/opbpay-ui-core-models';
// Types
import { CancelDropModalFooterTrackingHandlersType } from './types/cancel-drop-modal-footer.tracking.handlers.type';
import { TrackBuilderType } from 'types/track-builder.type';

const confirmCancelApplicationClickTrackingHandler = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'modalContainer/cancelLoanApplication',
    element: 'confirm',
    eventAction: 'modalCancelLoanApplication',
    eventCategory: 'modalCancelLoanApplicationConfirm',
    eventLabel: 'confirmButton',
  },
  type: TrackingEventsEnumeration.LINK,
});

const confirmDropApplicationClickTrackingHandler = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'modalContainer/loanApplication',
    element: 'confirm',
    eventAction: 'modalLoanApplication',
    eventCategory: 'modalLoanApplicationConfirm',
    eventLabel: 'confirmButton',
  },
  type: TrackingEventsEnumeration.LINK,
});

const CancelDropModalFooterTrackingHandlers = (
  track: TrackBuilderType
): CancelDropModalFooterTrackingHandlersType => ({
  handleConfirmCancelApplicationClickTracking: () =>
    track(confirmCancelApplicationClickTrackingHandler()),
  handleConfirmDropApplicationClickTracking: () =>
    track(confirmDropApplicationClickTrackingHandler()),
});

export { CancelDropModalFooterTrackingHandlers };
